module.exports = __webpack_public_path__ + "static/media/hcm.ba22929b.svg";